import * as React from 'react';
import {useContext, useEffect, useState} from 'react';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import Button from '@mui/material/Button';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import {DeleteForeverOutlined, FastfoodRounded, SaveOutlined} from "@mui/icons-material";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import {useTheme} from "@mui/material";
import {doc, updateDoc} from "firebase/firestore";
import {db} from "../utils/firebaseApp";
import {AppContext} from "../utils/AppContext";

export default function MenuSideDrawer({open, setOpen, standUid}) {
    const [menuItems, setMenuItems] = useState([])
    const [name, setName] = React.useState('');
    const [price, setPrice] = React.useState(0);
    const {state: {currentUser, stands, users}, dispatch} = useContext(AppContext);
    const [stand, setStand] = useState(null)

    const theme = useTheme()
    console.log(open)

    useEffect(() => {
        if (!stands) return
        console.log(stands)
        const menuItems = stands.filter(s => s.uid === standUid)[0]?.items
        const stand = stands.filter(s => s.uid === standUid)[0]
        console.log(stand)
        console.log(menuItems)
        if (stand) setStand(stand)
        if (menuItems) setMenuItems(menuItems)
        else setMenuItems([])
    }, [standUid])


    function addMenuItem() {
        setMenuItems([...menuItems, {name: name, price: parseInt(price)}])
        setPrice(0)
        setName('')
    }

    async function handleClose() {
        try {
            console.log('updating')
            const ref = doc(db, "stands", standUid);
            await updateDoc(ref, {items: menuItems})
            setOpen(false)
        } catch (e) {
            console.log(e)
        }
    }

    function deleteItem(name) {
        setMenuItems(menuItems.filter(i => i.name !== name))
    }

    if (!stand) return null

    return (
        <Drawer open={open} onClose={() => handleClose()} sx={{height: '100vh'}}>
            <Box sx={{
                maxWidth: 500,
                minWidth: 400,
                backgroundColor: theme.palette.primary.offWhite,
                // minHeight: '100%',
                height: '100%',
                padding: 2,
                paddingTop: 9
            }} role="presentation">
                <Typography variant={'h3'} sx={{textAlign: 'center', mt: 1}}><strong>Meni: {stand.name}</strong></Typography>
                <List>
                    <ListItem>
                        <TextField
                            value={name}
                            onChange={e => setName(e.target.value)}
                            margin="normal"
                            fullWidth
                            id="item"
                            label="naziv proizvoda"
                            required
                            name="text"
                            placeholder={'neko pivo'}
                            variant={'outlined'}
                            autoFocus={true}
                        />
                        <TextField
                            value={price}
                            onChange={e => setPrice(e.target.value)}
                            margin="normal"
                            id="item"
                            label="cena proizvoda"
                            required
                            name="text"
                            placeholder={'200'}
                            variant={'outlined'}
                            sx={{marginLeft: 1}}
                        />
                    </ListItem>

                    <ListItem>
                        <Button variant={"contained"}
                                fullWidth
                                disabled={name.length < 3}
                                onClick={() => addMenuItem()}>
                            <FastfoodRounded sx={{marginRight: 1}}/>
                            <Typography variant={"body1"}>Dodaj proizvod</Typography>
                        </Button>
                    </ListItem>
                    <Divider/>
                    {menuItems?.map((menuItem, index) => (
                        <ListItem key={menuItem}>
                            <ListItemIcon onClick={() => deleteItem(menuItem.name)}>
                                <DeleteForeverOutlined/>
                            </ListItemIcon>
                            <ListItemText primary={menuItem.name} secondary={menuItem.price}/>
                        </ListItem>
                    ))}
                </List>
            </Box>
            <Box sx={{
                position: 'sticky',
                bottom: 0,
                left: 0,
                width: '100%',
                zIndex: 10000,
                height: '40vh',
                background: 'linear-gradient(to top, rgba(255, 255, 255), transparent)',
                display: 'flex',
                alignContent: 'center',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: theme.palette.primary.offWhite,

            }}>
                <Button variant={'contained'}
                        sx={{width: '100%', margin: 2, backgroundColor: theme.palette.confirmation.main}}
                        onClick={() => handleClose()}
                ><SaveOutlined sx={{marginRight: 1}}/> Sačuvaj</Button>
            </Box>
        </Drawer>
    );
}
